import { Box, Button, Stack, Text } from "@chakra-ui/react"

interface ResultsPaginationProps {
  page: number
  pageSize: number
  count: number
  onPageChange: (page: number) => void
}

export function ResultsPagination({
  page,
  pageSize,
  count,
  onPageChange,
}: ResultsPaginationProps) {
  const totalPages = Math.max(1, Math.ceil(count / pageSize))
  return (
    <Box mt={3}>
      <Stack direction="row" align="center" justify="flex-end" gap={3}>
        <Button
          size="sm"
          variant="outline"
          aria-label="Previous page"
          disabled={page <= 0}
          onClick={() => onPageChange(page - 1)}
        >
          Prev
        </Button>
        <Text fontSize="sm">
          Page {page + 1} of {totalPages}
        </Text>
        <Button
          size="sm"
          variant="outline"
          aria-label="Next page"
          disabled={page >= totalPages - 1}
          onClick={() => onPageChange(page + 1)}
        >
          Next
        </Button>
      </Stack>
    </Box>
  )
}
